import React, { createContext } from 'react';

const AppConfigContext = createContext()

export const redirect = (location) => {
    window.location.href = '/builder/pokeland/' + location;
}

export const axios_timeout = 8000;

const AppConfig = ({ children, production }) => {
    let base_url;
    let local_env;
    let url;

    if (production) {
        local_env = false;
        localStorage.removeItem('localhost_env');
    } else {
        local_env = true;
        localStorage.setItem('localhost_env', true);
    }

    base_url = `${local_env ? 'http://localhost:3000/' : 'https://pokeland-legends.club/'}builder/pokeland/`

    function site_url(segments) {
        if (segments)
            return base_url + segments;
        else
            return base_url;
    }

    function assets_url(filename) {
        return 'https://pokeland-legends.club/public/assets/img/' + filename
    }

    function api_url(endpoint) {
        production ? url = "https://backend.pokeland-legends.club/pokeland-api/" : url = "http://localhost:3001/pokeland-api/";
        return url + endpoint;
    };

    function uri_segment(segment) {
        if (!segment)
            return window.location.href.split('/').at(-1) // Returns the last uri segment
        else if (segment < 0)
            return window.location.href.split('/').at(segment)
        else
            return window.location.href.split('/')[segment]
    }

    function navigate_to(segments) {
        if (segments) {
            return `/builder/pokeland/${segments}`
        }
        return `/builder/pokeland`
    }

    const env = () => {
        return production
    }

    return (
        <AppConfigContext.Provider value={{ site_url, uri_segment, api_url, assets_url, navigate_to, env }} site_url={site_url}>
            {children}
        </AppConfigContext.Provider>
    );
}

export { AppConfigContext, AppConfig }